import FileUpload from "components/FileUpload";
import { useTooltip } from "context/TooltipProvider";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { editSuspectToWitness } from "services/caseServices";
import { SuspectTowitness } from "types";
import { errorHandlerOnForm } from "utils/helper";

type Props = {
  conversion: SuspectTowitness;
  onClose: (refetch: boolean) => void;
};

const EditSuspectToWitnessForm: FC<Props> = ({ conversion, onClose }) => {
  const navigate = useNavigate();
  const { showTooltip } = useTooltip();
  // const [loading, setLoading] = useState(false);
  const [formState, setFormState] = useState<SuspectTowitness>(conversion);

  useEffect(() => {
    if (conversion) {
      setFormState(conversion);
    }
  }, [conversion]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formState.crime_registration_number)
      return "Crime Registration Number is Required.";
    else if (!formState.incident_registration_number)
      return "Incident Registration Number is Required.";
    else if (!formState.prosecutor_registration_number)
      return "Prosecutor Registration Number is Required.";

    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }

    // setLoading(true);
    // Submit the FormData
    editSuspectToWitness({
      ...formState,
      decision: "Pending",
      status: "forwarded_to_cordinator",
    })
      .then(() => {
        showTooltip("Successfully Submitted!", "success");
        onClose(true);
      })
      .catch((error) => {
        showTooltip(
          error?.response?.data?.detail || errorHandlerOnForm(error),
          "error"
        );
      });
    // .finally(() => setLoading(false));
  };
  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose(false);
    }
  };

  const handleFile = (name: string, file: File | null) => {
    setFormState({ ...formState, [name]: file });
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="relative w-full max-w-2xl bg-white p-8 shadow-lg rounded-lg overflow-y-auto">
        <h2 className="mb-1 text-2xl font-semibold">Edit Suspect to Witness</h2>
        <p className="mb-6 text-xs font-light text-[#9D9D9D]">
          Lorem Ipsum is a publishing industries as a temporary filler.
        </p>

        <form onSubmit={handleSubmit}>
          <div className=" ">
            <div>
              <div className="grid grid-cols-2 gap-4 mt-4">
                {/* Select Suspect (first) */}
                <div className="flex flex-col mt-4 col-span-2">
                  <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                    Select Suspect
                  </label>
                  <input
                    type="text"
                    placeholder="#123456"
                    className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                    value={
                      conversion?.suspect_info?.first_name +
                      " " +
                      conversion?.suspect_info?.middle_name +
                      " " +
                      conversion?.suspect_info?.last_name
                    }
                    disabled
                  />
                </div>
                {/* Crime Registration Number */}
                <div className="flex flex-col mt-4">
                  <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                    Crime Registration Number
                  </label>
                  <input
                    type="text"
                    placeholder="#123456"
                    className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                    name="crime_registration_number"
                    value={formState?.crime_registration_number ?? ""}
                    onChange={(e) => {
                      setFormState({
                        ...formState,
                        crime_registration_number: e.target.value,
                      });
                    }}
                    // disabled
                  />
                </div>
                {/* Incident Registration Number */}
                <div className="flex flex-col mt-4">
                  <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                    Incident Registration Number
                  </label>
                  <input
                    type="text"
                    placeholder="#123456"
                    className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                    name="incident_registration_number"
                    value={formState?.incident_registration_number ?? ""}
                    onChange={(e) => {
                      setFormState({
                        ...formState,
                        incident_registration_number: e.target.value,
                      });
                    }}
                    disabled
                  />
                </div>
                {/* Prosecutor Registration Number */}
                <div className="flex flex-col mt-4">
                  <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                    Prosecutor Registration Number
                  </label>
                  <input
                    type="text"
                    placeholder="#123456"
                    className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                    name="prosecutor_registration_number"
                    value={formState?.prosecutor_registration_number ?? ""}
                    onChange={handleChange}
                  />
                </div>
                {/* Agreement With Suspect */}
                <div className="flex flex-col mt-4">
                  <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                    Agreement With Suspect
                  </label>
                  <select
                    className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                    name="agreement_with_suspect"
                    value={formState?.agreement_with_suspect ? "true" : "false"}
                    onChange={(e) =>
                      setFormState({
                        ...formState,
                        agreement_with_suspect: e.target.value === "true",
                      })
                    }
                  >
                    <option value="false">No</option>
                    <option value="true">Yes</option>
                  </select>
                </div>
                {/* Request Date */}
                <div className="flex flex-col mt-4">
                  <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                    Request Date
                  </label>
                  <input
                    type="date"
                    className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                    name="request_date"
                    value={
                      formState?.request_date
                        ? typeof formState.request_date === "string"
                          ? formState.request_date.substring(0, 10)
                          : ""
                        : ""
                    }
                    onChange={handleChange}
                  />
                </div>
                {/* Decision */}
                <div className="flex flex-col mt-4">
                  <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                    Decision
                  </label>
                  <select
                    className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                    name="decision"
                    value={formState?.decision ?? "Pending"}
                    disabled
                  >
                    <option value="Pending">Pending</option>
                  </select>
                </div>

                <div className="flex flex-col mt-4 col-span-2">
                  <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                    Conversion Summary
                  </label>
                  <textarea
                    className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                    name="conversion_summary"
                    value={formState?.conversion_summary ?? ""}
                    onChange={handleChange}
                    rows={4}
                  />
                </div>
              </div>
              <div className="flex flex-col mt-4 col-span-2">
                <FileUpload
                  label="Agreement With Suspect File"
                  fileTypes="*"
                  required={true}
                  onChange={(file) =>
                    handleFile("agreement_with_suspect_file", file)
                  }
                />
              </div>
            </div>
          </div>

          <div className="flex flex-row mt-4 gap-3">
            {
              <input
                type="reset"
                className="border border-[#212121] px-[76px] py-3 text-[#747474] font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#D4D4D4]"
                value={"Cancel"}
                onClick={() => navigate(-1)}
              />
            }
            <input
              type="submit"
              className="border border-[#212121] bg-[#212121] px-[76px] py-3 text-white font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]"
              value={"Edit"}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditSuspectToWitnessForm;
